export const table = {
  MuiTable: {
    variants: [
      {
        props: { variant: "custom" },
        style: {
          // "& .MuiTableHead-root .MuiTableRow-root": {
          //   backgroundColor: "#FAFCFC",
          //   borderRadius: "10%",
          // },
          // "& .MuiTableCell-root": {
          //   fontWeight: 500,
          //   color: "green",
          // },
        },
      },
    ],
    styleOverrides: {
      // Name of the slot
      root: ({ theme }) => ({
        "& .MuiTableCell-head": {
          backgroundColor: theme.palette.grey[50],
          color: theme.palette.text.secondary,
          fontWeight: 500,
          fontSize: "12px",
        },
        "& .MuiTableBody-root .MuiTableCell-root": {
          fontWeight: 500,
          fontSize: "14px",
          color: theme.palette.text.main,
        },
      }),
    },
  },

  // MuiTableCell: {
  //   styleOverrides: {
  //     // Name of the slot
  //     root: {
  //       // fontWeight: 400,
  //       // color: "green"
  //     },
  //     head: {
  //       fontWeight: 700,
  //       color: "blue",
  //     },
  //   },
  // },
};
